import { NgModule } from '@angular/core';
import { RelatedblogsComponent } from './relatedblogs.component';
import { IonicModule } from '@ionic/angular';
import { BlogService } from '../../services/blog/blog.service';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    FontAwesomeModule,
    RelatedblogsComponent
],
    providers: [BlogService],
    exports: [RelatedblogsComponent]
})

export class RelatedblogsModule {}
